<div class="grid text-700">

  <div
    class="col-12 md:col-6"
    [class.info-window-summary--centered]="shouldCenterSummaryCard">
    <p-card styleClass="surface-card shadow-3 border-round h-full text-sm line-height-3">
      <div class="flex justify-content-between">
        <div>
          <span class="block mb-2 text-700 text-base font-semibold line-height-2">Última passagem</span>
          <div class="text-900 text-base font-semibold line-height-1 white-space-nowrap">
            {{data.lastFlow ? (data.lastFlow | date : "dd/MM/yyyy HH:mm:ss") : 'Sem passagem'}}
          </div>
        </div>

        <div
          class="flex align-items-center justify-content-center bg-blue-100 border-round"
          style="width:2.5rem;height:2.5rem">
          <i class="fa-solid fa-car-side text-blue-500 text-xl"></i>
        </div>
      </div>


      <ng-container *ngIf="hasFlowPerTrack">
        <p-divider class="w-full" align="center" type="dashed">
          <span class="text-700 text-sm font-semibold">Passagem por pista</span>
        </p-divider>

        <div
          *ngFor="let track of flowPerTrack let first = first"
          class="flex align-items-center justify-content-between py-2"
          [class.border-top-1]="!first"
          [class.surface-border]="!first">

          <div class="flex align-items-center gap-3">
            <i class="fa-solid fa-road text-blue-400 text-sm"></i>
            <span class="text-700 text-sm font-medium">
              {{track.trackLabel}}
            </span>
          </div>

          <span class="text-700 text-sm font-normal white-space-nowrap">
            {{track.lastFlow ? (track.lastFlow | date : "dd/MM/yyyy HH:mm:ss") : 'Sem passagem'}}
          </span>
        </div>
      </ng-container>
    </p-card>
  </div>


  <div
    *ngIf="data.groupId &&
           data.groupId!=GroupEnum.SERRA_GAUCHA &&
           data.groupId!=GroupEnum.VIA_ARAUCARIA &&
           data.groupId != GroupEnum.BR381 &&
           data.groupId!=GroupEnum.SANTAMARIA &&
           data.groupId!=GroupEnum.PRF"
    class="col-12 md:col-6">

    <p-card styleClass="surface-card shadow-3 border-round text-sm line-height-3">
      <div class="flex justify-content-between">
        <div>
          <span class="block mb-2 text-700 text-base font-semibold line-height-2">Última pesagem</span>
          <div class="text-900 text-base font-semibold line-height-1 white-space-nowrap">
            {{data.lastWeighing ? (data.lastWeighing | date : "dd/MM/yyyy HH:mm:ss") : 'Sem pesagem'}}
          </div>
        </div>

        <div
          class="flex align-items-center justify-content-center bg-cyan-100 border-round"
          style="width:2.5rem;height:2.5rem">
          <i class="fa-solid fa-truck text-cyan-500 text-xl"></i>
        </div>
      </div>
    </p-card>
  </div>


  <div
    *ngIf="data.groupId &&
           data.groupId!=GroupEnum.SERRA_GAUCHA &&
           data.groupId!=GroupEnum.ESPIRITO_SANTO &&
           data.groupId!=GroupEnum.VIA_ARAUCARIA &&
           data.groupId!=GroupEnum.SANTAMARIA &&
           data.groupId!=GroupEnum.PRF"
    class="col-12 md:col-6">

    <p-card styleClass="surface-card shadow-3 border-round text-sm line-height-3">
      <div class="flex justify-content-between">
        <div>
          <span class="block mb-2 text-700 text-base font-semibold line-height-2">Última infração</span>
          <div class="text-900 text-base font-semibold line-height-1 white-space-nowrap">
            {{data.lastViolation ? (data.lastViolation | date : "dd/MM/yyyy HH:mm:ss") : 'Sem infração'}}
          </div>
        </div>

        <div
          class="flex align-items-center justify-content-center bg-orange-100 border-round"
          style="width:2.5rem;height:2.5rem">
          <i class="fa-solid fa-road-bridge text-orange-500 text-xl"></i>
        </div>
      </div>
    </p-card>
  </div>

  <div class="col-12 mt-2 mb-2">
    <p-divider align="center">
      <span class="p-tag font-medium border-round" style="background-color: #00bcd4; color: white;">Informações do Equipamento</span>
    </p-divider>
  </div>


  <div class="col-12">
    <p-card styleClass="surface-card shadow-3 border-round text-sm line-height-3">
      <div
        class="equipment-location-layout"
        [class.equipment-location-layout--full]="!hasEquipmentPerformanceData">
        <div class="equipment-location-section">
          <div class="equipment-section-heading">
            <span class="block text-700 text-base font-semibold line-height-2 flex align-items-center">
              Dados de GPS
            </span>

            <div class="equipment-location-action">
              <p-button
                icon="pi pi-external-link"
                [text]="true"
                severity="info"
                pTooltip="Abrir localização no mapa"
                tooltipPosition="top"
                ariaLabel="Abrir localização do equipamento no mapa"
                (onClick)="openEquipmentLocation()">
              </p-button>
            </div>
          </div>

          <div class="equipment-info-row mt-2">
            <span class="flex align-items-center gap-2 min-w-0">
              <i class="fa-solid text-green-500 text-xs">x</i>
              <span class="font-semibold">Latitude atual:</span>
            </span>
            <span>
              {{data.latitude !== null && data.latitude !== undefined && data.latitude !== ''
                ? data.latitude
                : 'Não disponível'}}
            </span>
          </div>

          <div class="equipment-info-row mt-2">
            <span class="flex align-items-center gap-2 min-w-0">
              <i class="fa-solid text-green-500 text-xs">y</i>
              <span class="font-semibold">Longitude atual:</span>
            </span>
            <span>
              {{data.longitude !== null && data.longitude !== undefined && data.longitude !== ''
                ? data.longitude
                : 'Não disponível'}}
            </span>
          </div>
        </div>

        <ng-container *ngIf="hasEquipmentPerformanceData">
          <p-divider class="equipment-location-divider" layout="vertical"></p-divider>

          <div class="equipment-location-section">
            <div class="equipment-section-heading">
              <span class="block text-700 text-base font-semibold line-height-2">Desempenho do equipamento</span>
            </div>

            <div
              class="equipment-info-row mt-2"
              pTooltip="Média de OCR das últimas 100 passagens do equipamento."
              tooltipPosition="top">
              <span class="flex align-items-center gap-2 min-w-0">
                <i class="fa-solid fa-eye text-orange-500 text-xs"></i>
                <span class="font-semibold">OCR:</span>
              </span>
              <span>
                {{ocrEquipmentReading !== '' ? ocrEquipmentReading + '/100' : 'Sem dados de OCR.'}}
              </span>
            </div>

            <div
              class="equipment-info-row mt-2"
              pTooltip="Percentual de disponibilidade do equipamento da última hora."
              tooltipPosition="top">
              <span class="flex align-items-center gap-2 min-w-0">
                <i class="fa fa-hourglass-end text-orange-500 text-xs"></i>
                <span class="font-semibold">Disponibilidade:</span>
              </span>
              <span>
                {{equipmentAvailability !== '' ? equipmentAvailability + '%' : 'Sem dados de disponibilidade.'}}
              </span>
            </div>
          </div>
        </ng-container>

      </div>
    </p-card>
  </div>

</div>
